import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ngb-delete-modal-content',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{name}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross')">
      </button>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to delete? </p>   
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="activeModal.close('Delete')">Delete</button>
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Cancel')">Cancel</button>
    </div>  `
})
export class NgbDeleteModalContent {
  @Input() name;

  constructor(public activeModal: NgbActiveModal) { }
}
